module.exports = __webpack_public_path__ + "static/img/smart.536dd2a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/works/smart.jpg
// module id = NU1S
// module chunks = 1